import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister as register } from "../redux/slices/clientSlice";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { useNotification } from "../components/Notification";

const Register = ({ handleClose, prefillData }) => {
  const { showNotification } = useNotification();
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    companyName: "",
    name: "",
    email: "",
    phoneNumber: "",
    location: "",
    roomNumber: "",
    googleLink: "",
    docLink: "",
    isAdmin: true,
    isAdminX: false,
    model: {
      b2b: false,
      b2c: false,
      adminX: false,
    },
    services: {
      maids: { enabled: false, flow: "", feeOption: false },
      valets: { enabled: false, flow: "", feeOption: false },
      bellmen: { enabled: false, flow: "", feeOption: false },
      airbnb: { enabled: false, flow: "", feeOption: false },
    },
  });
  const [isAdminX, setIsAdminX] = useState(false);
  const [name, setName] = useState("");
  const [googleLink, setGoogleLink] = useState("");
  const [docLink, setDocLink] = useState("");
  const [accountStatus, setAccountStatus] = useState(false);
  const [email, setEmail] = useState("");
  const [roomNumber, setRoomNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [location, setLocation] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(true);
  const [message, setMessage] = useState(null);

  const SERVICE_LABELS = {
    maids: "Attendants",
    valets: "Valet",
    bellmen: "Belldesk",
    airbnb: "Airbnb",
  };

  let partnerId;
  let adminXId;

  const dispatch = useDispatch();

  const {
    registerLoading: loading,
    registerError: error,
    registerSuccess: success,
  } = useSelector((state) => state.client);

  const { user } = useSelector((state) => state.userDetails);
  const userId = user._id;

  // Generic handler for fields
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Handler for model fields
  const handleModelChange = (field) => {
    setFormData((prev) => ({
      ...prev,
      model: { b2b: false, b2c: false, adminX: false, [field]: true },
    }));
  };

  // Handler for service fields
  const handleServiceToggle = (service, checked) => {
    setFormData((prev) => ({
      ...prev,
      services: {
        ...prev.services,
        [service]: { enabled: checked },
      },
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    setValidated(true);

    if (form.checkValidity() === true) {
      setMessage(null);

      if (user.isAdminX) {
        partnerId = user.partnerId;
        adminXId = userId;
      } else {
        partnerId = userId;
        adminXId = null;
      }
      dispatch(register({ ...formData, partnerId, adminXId, isAdminX }));
    }
  };

  //Auto-populate if prefillData exists
  useEffect(() => {
    if (prefillData) {
      setFormData((prev) => ({
        ...prev,
        companyName: prefillData.basicDetails?.hotelName || "",
        name: prefillData.basicDetails?.pointOfContact || "",
        email: prefillData.basicDetails?.contactEmail || "",
        location: prefillData.basicDetails?.hotelAddress || "",
        roomNumber: prefillData.basicDetails?.numberOfRooms || "",

        services: {
          ...prev.services,
          maids: {
            enabled: prefillData.services.some(
              (s) => s.department === "Housekeepers" && s.enabled
            ),
          },
          valets: {
            enabled: prefillData.services.some(
              (s) => s.department === "Valets" && s.enabled
            ),
          },
          bellmen: {
            enabled: prefillData.services.some(
              (s) => s.department === "Bell Desk" && s.enabled
            ),
          },
        },
      }));
    }
  }, [prefillData]);
  return (
    <>
      <Row className="px-5 my-3">
        <Col>
          {error ? <Message>{error}</Message> : null}
          {message ? <Message variant="danger">{message}</Message> : null}
          {loading ? (
            <Loader />
          ) : (
            <Form noValidate validated={validated} onSubmit={submitHandler}>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      value={formData.companyName}
                      onChange={(e) =>
                        handleChange("companyName", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Contact Person Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      pattern="[A-Za-z ]+"
                      value={formData.name}
                      onChange={(e) => handleChange("name", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      value={formData.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Enter a valid Email*
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      required
                      type="tel"
                      pattern="^[0-9+ ]+$"
                      value={formData.phoneNumber}
                      onChange={(e) =>
                        handleChange("phoneNumber", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={formData.location}
                  onChange={(e) => handleChange("location", e.target.value)}
                />
              </Form.Group>

              {/* ---- Services ---- */}
              <h5 className="mt-4">Services</h5>
              <Row>
                {Object.keys(formData.services).map((serviceKey) => (
                  <Col className="border border-1 p-2 mx-1 rounded-2">
                    <Form.Check
                      key={serviceKey}
                      type="checkbox"
                      label={SERVICE_LABELS[serviceKey]}
                      checked={formData.services[serviceKey].enabled}
                      onChange={(e) =>
                        handleServiceToggle(serviceKey, e.target.checked)
                      }
                    />
                  </Col>
                ))}
              </Row>
              {Object.values(formData.services).every((s) => !s.enabled) && (
                <Form.Text className="text-muted fst-italic">
                  Please select at least one service
                </Form.Text>
              )}

              {/* ---- Client Model ---- */}
              <h5 className="mt-4">Client Model</h5>
              <Row>
                <Col>
                  <Form.Check
                    type="radio"
                    label="B2B"
                    name="clientModel"
                    checked={formData.model.b2b}
                    onChange={() => handleModelChange("b2b")}
                    required
                  />
                </Col>
                <Col>
                  <Form.Check
                    type="radio"
                    label="B2C (1099 Model)"
                    name="clientModel"
                    checked={formData.model.b2c}
                    onChange={() => handleModelChange("b2c")}
                    required
                  />
                </Col>
                <Form.Control.Feedback type="invalid">
                  Please select either B2B or B2C
                </Form.Control.Feedback>
                {user.isAdminX && (
                  <Col>
                    <Form.Check
                      disabled={!user.chargesStatus}
                      type="radio"
                      label="Connected"
                      checked={formData.model.adminX}
                      onChange={() => handleModelChange("adminX")}
                    />
                    {!user.chargesStatus && (
                      <Form.Text
                        className="text-danger"
                        style={{ fontSize: "10px" }}
                      >
                        Stripe account not completed!
                      </Form.Text>
                    )}
                  </Col>
                )}
              </Row>

              <Row className="mt-5 align-items-center">
                {user.isSuperAdmin === true && (
                  <Col>
                    <Form.Check
                      type="checkbox"
                      id="adminXCheckBox"
                      label="Make an Admin X"
                      checked={isAdminX}
                      onChange={(e) => setIsAdminX(e.target.checked)}
                    />
                  </Col>
                )}
                <Col sm="auto" className="ms-auto">
                  <Button type="submit" className="btn-success px-5">
                    Register
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Col>
      </Row>
    </>
  );
};

export default Register;
